import React from "react";
import Grid from '@mui/material/Grid';
import {TextField, Button, Typography } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment } from '@mui/material';
const ForgotPasswordForm = ({
    formData,
    errors,
    showPassword,
    password,
    onChange,
    sentOtp,
    handleSubmit,
    isLoading,
    handleClickPasswordShowOff,
    enterOtp,
    serverError
})=>{
    return(
        <>
            <Grid item className="stepper_wrapper" sx={{ p: 4 }}
            md="12"
            xs="12">
              <div className="title_container mb-20">
            <h2>Forgot Your Password? Reset It Now!</h2>
          </div>
                {serverError && (
                        <Typography color="error" sx={{ mb: 2 }}>
                            {serverError}
                        </Typography>
                    )}

                <TextField 
                fullWidth
                value={formData?.email || ""}
                error={!!errors?.email}
                helperText ={errors?.email}
                placeholder="Enter Email ID"
                onChange={(e)=> onChange("email", e.target.value)}
                disabled={isLoading || sentOtp} // Disable when loading or OTP sent
                >                
                </TextField>

                {sentOtp && (
                    <>
                    <Grid xs={12} sx={{ marginTop: '20px' }}>
                <TextField  
                fullWidth
                error={!!errors?.otp}
                value={formData?.otp || ''}
                helperText={errors?.otp}
                placeholder="Plesae enter 4 digit otp"
                onChange={(e)=> onChange('otp', e.target.value)}
                disabled={isLoading}
                >
                </TextField></Grid><Grid xs={12} sx={{ marginTop: '20px' }}>
                <TextField 
                                fullWidth
                                label="Password"
                                type={showPassword.password1 ? "text" : "password"}
                                value={formData.password}
                                onChange={(e)=> onChange('password', e.target.value)}
                                error={!!errors.password}
                                helperText={errors.password}
                                InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end" sx={{marginLeft:"10px", marginRight:"10px"}}>
                                            <IconButton
                                              aria-label="toggle password visibility"
                                              onClick={()=> handleClickPasswordShowOff('password1')}
                                              edge="end"
                                            >
                                              {showPassword.password1 ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                          </InputAdornment>
                                        ),
                                      }}
                                /></Grid>
<Grid xs={12} sx={{ marginTop: '20px' }}>
                                <TextField 
                                                fullWidth
                                                label="Confirm Password"
                                                type={showPassword.password2 ? "text" : "password"}
                                                value={formData.confirmPassword}
                                                onChange={(e)=> onChange('confirmPassword', e.target.value)}
                                                error={!!errors.confirmPassword}
                                                helperText={errors.confirmPassword}
                                                InputProps={{
                                                        endAdornment: (
                                                          <InputAdornment position="end" sx={{marginLeft:"10px", marginRight:"10px"}}>
                                                            <IconButton 
                                                              aria-label="toggle password visibility"
                                                              onClick={()=> handleClickPasswordShowOff('password2')}
                                                              edge="end" 
                                                            >
                                                              {showPassword.password2 ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                          </InputAdornment>
                                                        ),
                                                      }}
                                                /></Grid>
                </>
                )}
                <Grid xs={12} sx={{ marginTop: '20px' }}>
                <Button
                fullWidth
                disabled={isLoading}
                onClick={handleSubmit}
                className="btn-default mt-10 btn-lg"
                >
                  {isLoading? 'Loading ...' :  (sentOtp? "Verify & Reset Password" : "Send OTP")}
                </Button>
                </Grid>
            </Grid>
        </>
    )
}
export {ForgotPasswordForm}